import script from "./ChatbotToolApprovalRequest.ce.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatbotToolApprovalRequest.ce.vue?vue&type=script&setup=true&lang=js"

import _style_0 from "./ChatbotToolApprovalRequest.ce.vue?vue&type=style&index=0&id=bbf6c42c&inline&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]]])

export default __exports__